import React from 'react';
import bubbleGif from '../../../images/gif/bubble.gif';
import giftImg from '../../../images/webp/gift.webp';

const ContactHeader = () => {
    return (
        <div style={{ backgroundImage: `url(${bubbleGif})`, backgroundSize: 'cover', backgroundPosition: 'center', color: 'white', borderRadius: 20 }} className="text-center pt-5 mb-5">
            <h4 data-aos="fade-up" data-aos-duration="500" className="style-font">Be event</h4>

            <h1 data-aos="fade-up" data-aos-duration="1500" className="fw-bolder">
                Contact Us <br />
            <span style={{ fontSize: 20, padding: '0 3px', border: '2px solid gray', borderRadius: 5, color: 'white' }}>if</span><span style={{ color: '#ff3465' }}>any Questions </span><br />
                any questions <br />
            </h1>
            <p data-aos="fade-up" data-aos-duration="2500">Erat scelerisque lobortis nisl sed elementum massa. Et eu viverra nisi, adipiscing mauris. Pulvinar phasellus mattis pellentesque posuere nunc.</p>
            <img data-aos="fade-up" data-aos-duration="3000" className="w-50" src={giftImg} alt="" />
        </div>
    );
};

export default ContactHeader;